import { joinCn } from '../util';

const style = {
  vBaseSelectItemList: joinCn('min-w-[146px]', 'border-y border-gray-200'),
  vBaseSelectItem: (disabled?: boolean) =>
    joinCn(
      'px-2',
      'h-(--height)',
      'border-b border-gray-200',

      'hover:relative',
      'hover:after:absolute hover:after:top-0 hover:after:left-0',
      'hover:after:h-full hover:after:w-full',
      'hover:after:content-[""]',
      'hover:after:shadow-sm',
      'hover:after:z-1',

      {
        'cursor-not-allowed text-gray-300': disabled,
        'cursor-pointer': !disabled,
      },
    ),
  vBaseSelectItemCheckIcon: (selected?: boolean) => {
    return joinCn(
      'h-5 w-5',
      selected ? 'text-secondary-300' : 'text-transparent',
    );
  },
  vBaseSelectItemLabel: joinCn(
    'w-full',
    'flex-1',
    'overflow-hidden  text-ellipsis whitespace-nowrap',
    'text-body-m',
  ),
} as const;

export default style;
